let navigateFunction;

export const initNavigationService = (navFn) => {
    navigateFunction = navFn;
};

export const redirectToLogin = () => {
    if (navigateFunction) {
        navigateFunction('/login');
    } else {
        window.location.href = '/login';
    }
};